/* @sravni/react-design-system version 0.2.59 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { CONTENT_SIZES } from '../../../constants/sizes.js';
import modules_e5067360 from '../styles/Icon.module.less.js';

/**
 * @description Icon container.
 *
 * @component
 * @example
 * ```jsx
 * <Icon size={28} icon={<ArrowUpIcon />} />
 * ```
 */
var Icon = React.forwardRef(function (props, ref) {
    var _a;
    var icon = props.icon, size = props.size, strong = props.strong, color = props.color, background = props.background, shape = props.shape, _b = props.style, style = _b === void 0 ? {} : _b, children = props.children, className = props.className, restProps = __rest(props, ["icon", "size", "strong", "color", "background", "shape", "style", "children", "className"]);
    var cx = useStyles(modules_e5067360);
    var classNames = cx(className, 'container', (_a = {
            strong: strong
        },
        _a["size-" + size] = size,
        _a["color-" + color] = color,
        _a["background-" + background] = background,
        _a["shape-" + shape] = shape,
        _a.asContainer = children,
        _a));
    return (React.createElement("span", __assign({ "data-qa": "Icon", ref: ref, className: classNames, style: style }, restProps), children || icon));
});
Icon.defaultProps = {
    size: CONTENT_SIZES.S20,
    shape: 'round',
};
Icon.displayName = 'Icon';

export default Icon;
//# sourceMappingURL=Icon.js.map
